// 相关的 Action 层，负责业务逻辑和异步操作
import { action, makeObservable } from 'mobx';
import { PhotographyStore } from './store';
import { readPhotographyContestsList, readPhotographyContestsDetail, readPhotographyContestsWorks, readPhotographyWorks, readPhotographyExhibitions, readPhotographyContestMyWorks, readPhotographyContestMyVotes, deletePhotographyWork, readPhotographyWorksDetail, submitPhotographyWorksVote } from '@server/api';


export class PhotographyAction extends PhotographyStore {

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    /**
     * 获取摄影大赛列表
     */
    async getPhotographyContestsList(params) {
        const res = await readPhotographyContestsList(params);
        return res
    }

    /**
     * 获取摄影大赛详情
     */
    async getPhotographyContestsDetail(params) {
        const res = await readPhotographyContestsDetail(params);
        return res
    }

    /**
     * 获取摄影大赛投稿列表
     */
    async getPhotographyContestsWorks(id, params) {
        const res = await readPhotographyContestsWorks(id, params);
        return res
    }

    /**
     * 获取摄影大赛我的作品列表
     */
    async getPhotographyContestsMyWorks(id, params) {
        const res = await readPhotographyContestMyWorks(id, params);
        return res
    }

    /**
     * 获取摄影影展详情
     */
    async getPhotographyExhibitions(id, params) {
        const res = await readPhotographyExhibitions(id, params);
        return res
    }

    /**
     * 获取摄影大赛我的投票列表
     */
    async getPhotographyContestsMyVotes(id, params) {
        const res = await readPhotographyContestMyVotes(id, params);
        return res
    }
    
    /**
     * 删除作品
     */
    async deletePhotographyWorkData(id) {
        const res = await deletePhotographyWork(id);
        return res
    }

    /**
     * 获取摄影大赛投稿详情
     */
    async getPhotographyWorks(params) {
        const res = await readPhotographyWorks(params);
        return res
    }

    /**
     * 获取摄影大赛某个作品详情
     */
    async getPhotographyWorksDetail(id) {
        const res = await readPhotographyWorksDetail(id);
        console.log(res, '方法11111');
        return res
    }
    
    /**
     * 获取摄影大赛某个作品详情
     */
    async submitPhotographyWorksVoteData(id) {
        const res = await submitPhotographyWorksVote(id);
        return res
    }
    

}

// 单例导出，方便全局调用
export default new PhotographyAction();